angular.module('mercury.modules.time.roster')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Time.RosterEdit', {
    url: '/roster/edit?:report',
    templateUrl: 'modules/time/roster/edit.tpl.html',
    controller: 'TimeRosterEditCtrl'
  });

  $stateProvider.state('Time.RosterSettings', {
    url: '/roster/settings',
    templateUrl: 'modules/time/roster/settings.tpl.html',
    controller: 'TimeRosterSettingsCtrl'
  });

  $stateProvider.state('Time.RosterOverview', {
    url: '/roster/overview?:report',
    templateUrl: 'modules/time/roster/overview.tpl.html',
    controller: 'TimeRosterOverviewCtrl',
    date: {
      defaultReportType: 'Week'
    }
  });

  $stateProvider.state('Time.RosterShiftReport', {
    url: '/roster/shiftreport?:report',
    templateUrl: 'modules/time/roster/shiftreport.tpl.html',
    controller: 'TimeRosterShiftReportCtrl'
  });

  // These 2 routes are for the Print actions in the menu but aren't accessable.
  // Actions are in the stateChangeStart listener in the time layout controller.
  // If the urls are manually navigated to, just redirect back to the default time page.
  $stateProvider.state('Time.RosterPrintByStaff', {
    url: '/roster/printbystaff',
    actionState: true,
    onEnter: ["$state", function($state) {
      $state.go('Time');
    }]
  });
  $stateProvider.state('Time.RosterPrintByRole', {
    url: '/roster/printbyrole',
    actionState: true,
    onEnter: ["$state", function($state) {
      $state.go('Time');
    }]
  });

  // React routes below
  $stateProvider.state('Time.RosterPublish', {
    url: '/roster/:rosterId/publish?start&end&report',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Time.RosterEdit'
    }
  });

  $stateProvider.state("Time.RosterCopy", {
    url: "/roster/copy?start&end&report&templateId",
    controller: "ReactCtrl",
    data: {
      menuLinkState: "Time.RosterEdit",
    },
  });

  $stateProvider.state('Time.RosterTemplates', {
    url: '/roster/templates',
    controller: 'ReactCtrl'
  });

  $stateProvider.state('Time.EditTemplate', {
    url: '/roster/templates/:templateId?:report',
    templateUrl: 'modules/time/roster/edit.tpl.html',
    controller: 'TimeRosterEditCtrl',
    data: {
      menuLinkState: "Time.RosterTemplates",
    },
  });
}]);
